import { SyntheticEvent, useCallback } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { useProductQuery } from "../../../../../api/services";
import { FormAutocomplete } from "../../../../../components/fields";
import { ILocation, RentalLocationType } from "../../../../../types";
import { isBusinessContinuityMode, isLeisureCode, stepState } from "../../../recoil";
import { IFormValues, InsertBookingStep } from "../../../types";
import LocationHelperText from "../location-helper-text/LocationHelperText";

const FormDropoffLocation = () => {

    const { t } = useTranslation('booking');

    const step = useRecoilValue(stepState);
    const businessContinuityMode = useRecoilValue(isBusinessContinuityMode);
    const flagLeisureCode = useRecoilValue(isLeisureCode);

    const formContext = useFormContext<IFormValues>();

    const rentalType = useWatch<IFormValues, 'basicDetails.rentalType'>({
        name: 'basicDetails.rentalType'
    });
    const dropoffLocation = useWatch<IFormValues, 'basicDetails.dropoffLocation'>({
        name: 'basicDetails.dropoffLocation'
    });
    const customerCode = useWatch<IFormValues, 'basicDetails.customerCode'>({
        name: 'basicDetails.customerCode'
    });
    const tenant = useWatch({ control: formContext.control, name: "basicDetails.tenants" });
    const dealer = useWatch({ control: formContext.control, name: "basicDetails.dealers" });

    const locationsQuery = useProductQuery(
        {
            segment: rentalType,
            businessContinuityInsToolMode: businessContinuityMode,
            tenant: tenant as string,
            dealer: dealer as string
        },
        { 
            refetchOnMount: false,
            enabled: !flagLeisureCode
        }
    );

    const onChange = useCallback((_: SyntheticEvent<Element, Event>, value: ILocation | null) => {
        if (value) {
            formContext.trigger('basicDetails.dropoffLocation');
        }
        formContext.trigger('basicDetails.dropoffDate');
    }, [])

    return (
        <FormAutocomplete<IFormValues>
            name="basicDetails.dropoffLocation"
            label={t('label.dropoffLocation')}
            options={locationsQuery.data?.locations ?? []}
            onChange={onChange}
            loading={locationsQuery.isLoading}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            disabled={step === InsertBookingStep.CUSTOMER_DETAILS}
            textFieldProps={{
                helperText: <LocationHelperText location={dropoffLocation} locationType={RentalLocationType.Dropoff} />
            }}
        />
    );
}

export default FormDropoffLocation;
